import _ from "lodash"
import { createSelector } from "reselect"
import { IAppState } from "../../../app/appTypes"
import { IMeetingCase } from "../../../features/meetingCase/state/meetingCaseTypes"
import { getAllMeetingCases } from "../meeting"

const getCaseIdFromProps = (state: IAppState, ownProps: { caseId: string }): string =>
  ownProps.caseId

const getMeetingIdFromProps = (state: IAppState, ownProps: { meetingId: string }): string =>
  ownProps.meetingId

export const getMeetingCaseByMeetingAndCaseId = createSelector(
  getAllMeetingCases,
  getCaseIdFromProps,
  getMeetingIdFromProps,
  (allMeetingCases, caseId, meetingId): IMeetingCase => {
    return _.find(allMeetingCases, (meetingCase: IMeetingCase) => {
      return meetingCase.case == caseId && meetingCase.meeting == meetingId
    })
  }
)
